import Uploads from "../components/Uploads";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";
import MonthlyUploadDashboard from "../components/MonthlyUploadDashboard"; // 🆕 NEW
import { useState } from "react";

const UploadPage = () => {
  const [refresh, setRefresh] = useState(false);
  
  const handleUploadSuccess = () => {
    setRefresh((prev) => !prev); // toggle refresh trigger
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="sticky-top z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 overflow-hidden">
        <aside
          style={{
            position: "sticky",
            height: "calc(100vh - 120px)",
          }}
        >
          <Sidebar />
        </aside>
        <main className="w-100 overflow-auto w-25">
          <div className="header bg-theme-light pb-9 p-4">
            <div className="container-fluid">
              <div className="header-body">
                <div className="headnumText justify-content-between">
                  <div className="pageTitleWrap">
                    <h5>
                      <i className="bi bi-cloud-upload me-2"></i>
                      Upload Management
                    </h5>
                    <p className="text-muted mb-0">
                      Upload reports and track state-wise progress
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Upload Component */}
            <Uploads onUploadSuccess={handleUploadSuccess} />
            
            {/* Monthly Upload Dashboard */}
            <MonthlyUploadDashboard refresh={refresh} />
          </div>
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};

export default UploadPage;